import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import AuthenticationService from '../service/AuthenticationService';
import AuthService from '../security/AuthService';
import { useNavigate } from 'react-router-dom';

const CustomForgotPassword = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);


    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const checkButtonStatus = () => {

        if (username && password) {
            return false;
        }

        return true;

    }

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }


    const onLogin = () => {
        showLoading();
        //if (captchaCheck) {
        try {
            AuthenticationService.signin(username, password).then(response => {
                console.log("signin", response);

                if (response?.data?.error) {
                    hideLoading();
                    let _content = response?.data?.error?.message ? response?.data?.error?.message : response?.data?.error?.innerExceptionMessage;

                    if (t(_content)) {
                        _content = t(_content);
                    }



                    props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: _content, life: 5000 });


                } else if (response?.status >= 200 && response?.status < 300) {

                    console.log("signin", response);
                    console.log(JSON.stringify(response?.data?.data?.response));
                    const accessToken = response?.data?.data?.response;
                    console.log(accessToken);

                    AuthService.setAuthentication(accessToken);
                    setUsername('');
                    setPassword('');
                    if (props?.setDialogVisible) {
                        props?.setDialogVisible(false);
                    }
                    if (props?.op?.current) {
                        props.op.current.hide();

                    }
                    navigate('/')


                    props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });

                }
                else if (response?.status === 400) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                } else if (response?.status === 401) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                } else if (response?.status === 422) {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                } else {
                    hideLoading();
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                }
            })
                .catch(err => {
                    hideLoading();

                    if (!err?.response) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    } else if (err.response?.status === 400) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                    } else if (err.response?.status === 401) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                    } else if (err.response?.status === 422) {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                    } else {
                    }
                    console.error(err);
                });


        } catch (err) {
            hideLoading();
            if (!err?.response) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            } else if (err.response?.status === 400) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
            } else if (err.response?.status === 401) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
            } else if (err.response?.status === 422) {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
            } else {
                props.toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            }
            console.error(err);
            //	errRef.current.focus();
        }
    }

    const onForgotPassword = () => {

    }

    const authInfo = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  " >
                <div className=" w-12  ">
                    
                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">
                            <div className="col-12 md:col-12 mb-3">
                                <InputText id="username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="off"
                                    className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_user_name_or_email')}></InputText>
                            </div>
                            <div className="col-12 md:col-12 ">
                                <InputText type="password" placeholder={t("global_text_password")}
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    required
                                    className="inputtext_raunded p-inputtext  w-12"
                                />
                            </div>


                        </div>

                    </div>

                </div>
            </div>
        )

    }



    const renderButton = () => {

        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">
                <Button label={t('global_text_forgotpassword')} className="p-button-rounded mr-2 mb-2 " text
                    onClick={() => onForgotPassword()}></Button>

                <Button label={t('global_btn_login')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"

                    disabled={checkButtonStatus()} onClick={() => onLogin()}></Button>
            </div>
        )
    }

    return (
        <div style={{
            ...props.containerStyle,
            width: "100%"


        }}>

            {authInfo()}
            {renderButton()}
        </div>
    )
}

export default CustomForgotPassword;